import React from "react"
import "./BackButton.css"
import { getTranslation } from "../../../../assets/creator/translations"

const arrowLeft = (<svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
	<path d="M27.369 15H7.459l5.354-5.355a.999.999 0 1 0-1.415-1.414L3.633 16l7.767 7.77a.999.999 0 1 0 1.414-1.416L7.458 17h19.91a1 1 0 1 0 0-2" fill="#4A5DE2" />
	</svg>
)



// 
const BackButton = ({ onClick }) => (
	<div className="menu-back-button">
		<div className='back-button' onClick={onClick}>
			<div className='back-button__chevron'>{arrowLeft}</div>
			<span>{getTranslation("Back")}</span>
		</div>
		<div className='title'>
			{getTranslation("Sty_AdjustThemeColors")}
		</div>
	</div>
)

export default BackButton
